<template>
  <div id="home">
    <Map v-if="floors"
         :floor="current_floor"
         :position="position"
         :blueprint="floors[current_floor].path"
         :metadata="floors[current_floor].metadata"
         :path="path"
         :selected_rooms="[route_start, route_destination]"
         @room_selected="set_location" />

    <div id="select-floor" :class="[select_floor ? 'floor-select-opened' : 'floor-select-closed']">
      <svg v-if="select_floor"
           class="floor-select-opened"
           @click="select_floor=false"
           width="30" height="30" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
      </svg>
      <svg v-if="!select_floor"
           class="floor-select-closed"
           @click="select_floor=true"
           fill="white" viewBox="0 0 491 491" xmlns="http://www.w3.org/2000/svg">
        <path d="M487.3 326.7l-62.3-37 62.3-37.2a8 8 0 000-13.8l-62.3-37 62.3-37.2a8 8 0 000-13.8L249.7 9.1a8 8 0 00-8.2 0L4 150.7a8 8 0 000 13.8l62.3 37.1L4 238.7a8 8 0 000 13.8l62.3 37.1L4 326.7a8 8 0 000 13.8L241.5 482a8 8 0 008.2 0l237.6-141.6a8 8 0 000-13.8zm-463.7-169l222-132.4 222 132.3-222 132.3-222-132.3zm0 88l58.2-34.8 159.7 95.2a8 8 0 008.2 0L409.4 211l58.2 34.7-222 132.3-222-132.3zm222 220.2l-222-132.3L81.8 299l159.7 95.2a8 8 0 008.2 0L409.4 299l58.2 34.7-222 132.3z" />
      </svg>
      <div v-if="select_floor" v-html="floors[1].svg" @click="current_floor=1" :class="[current_floor===1 ? 'active-floor' : 'floor']"></div>
      <div v-if="select_floor" v-html="floors[2].svg" @click="current_floor=2" :class="[current_floor===2 ? 'active-floor' : 'floor']"></div>
      <div v-if="select_floor" v-html="floors[3].svg" @click="current_floor=3" :class="[current_floor===3 ? 'active-floor' : 'floor']"></div>
    </div>

    <div id="explore">
      <SearchBar :search_suggestions="search_suggestions"
                 @room_selected="set_location"
                 @open_route_card="select_route=true"
                 @update_suggestions="update_search_suggestions" />

      <div id="select-route" v-if="select_route">
        <svg class="close-card card-padding" @click="clear_route" width="30" height="30" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>

        <header>Route</header>

        <div class="select-place">
          <select v-if="route_start==='Your Location'" :value="position.z" @change="select_position($event)">
            <option>1</option>
            <option>2</option>
            <option>3</option>
          </select>
          <input v-model="route_start"
                 placeholder="Current Location"
                 @focus="endpoint_input_focus('start')"
                 @input="update_endpoint_suggestions" />
          <i class="material-icons">search</i>
        </div>
  
        <div class="select-place">
          <input v-model="route_destination"
                 placeholder="Destination"
                 @focus="endpoint_input_focus('end')"
                 @input="update_endpoint_suggestions" />
          <i class="material-icons">search</i>
        </div>

        <div id="location-search-result" v-if="endpoint_suggestions.length > 0">
          <div :key="place"
               @click="select_place(place, route_endpoint)"
               class="location-search-item"
               v-for="place in endpoint_suggestions">
            <i class="material-icons" :style="{ color: place==='Your Location' ? '#1a70f6' : '#859ba6'}">
              {{ place==='Your Location' ? 'my_location' : 'location_on' }}
            </i>
            {{ place }}
          </div>
        </div>
      </div>

      <div id="location" v-if="location.name.length > 0">
        <svg class="close-card card-padding" @click="clear_location" width="30" height="30" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
        </svg>

        <div id="location-info">
          <img id="room-icon" :src="location.src" alt="Room" />
          <h1>{{location.name}}</h1>
          <p>{{location.name}}, Floor {{location.floor}}</p>

          <div>
            <button @click="select_place(location.name, 'start')">
              <img src="../assets/location.svg" alt="Location" />
              Set Location
            </button>

            <button @click="select_place(location.name, 'end')">
              <img src="../assets/flag.svg" alt="Destination" />
              Set Destination
            </button>
          </div>
        </div>
      </div>
    </div>

    <div id="location-portrait" v-if="location.name.length > 0">
      <div id="pill-container" @click="location_popup=!location_popup">
        <div id="pill"></div>
      </div>

      <div id="location-info-portrait"
           v-if="location_popup">
        <h1>{{location.name}}</h1>
        <p>{{location.name}}, Floor {{location.floor}}</p>
      </div>

      <div id="location-portrait-buttons" v-if="location_popup">
        <button @click="select_place(location.name, 'start')">
          <img src="../assets/location.svg" alt="Location" />
          Set Location
        </button>

        <button @click="select_place(location.name, 'end')">
          <img src="../assets/flag.svg" alt="Destination" />
          Set Destination
        </button>
      </div>
    </div>

    <div v-if="open_app" id="open-app">
      <div><svg class="close-app-promo" @click="open_app=false" width="40" height="40" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg></div>
      <h1>Download WSHS Maps</h1>
      <p>This website is not optimized for mobile devices, so try downloading the official app for more features and a better user experience.</p>
      <a href="https://apps.apple.com/us/app/wshs-maps/id1638877055">Use the app</a>
    </div>
  </div>
</template>

<script>
import Map from '@/components/Map.vue'
import SearchBar from '@/components/SearchBar.vue'

export default {
  name: 'Home',
  components: {
    SearchBar,
    Map
  },
  data() {
    return {
      width: 0,
      floors: null,
      path: [],
      open_app: screen.width < 768,
      position: { x: null, y: null, z: 2 },
      current_floor: 2,
      select_floor: false,
      select_route: false,
      route_start: '',
      route_destination: '',
      route_endpoint: '',
      search_suggestions: [],
      endpoint_suggestions: [],
      location: {
        name: '',
        floor: 0,
        src: ''
      },
      location_popup: true
    }
  },
  metaInfo() {
    return {
      title: 'WSHS Maps',
      meta: [
        {
          name: 'description',
          content: 'Get walking directions to anywhere in WSHS that you so choose with WSHS Maps'
        }
      ],
      link: [
        { rel: 'stylesheet', href: 'https://fonts.googleapis.com/icon?family=Material+Icons' }
      ],
      htmlAttrs: {
        lang: 'en'
      }
    }
  },
  mounted() {
    let xhr = new XMLHttpRequest()
    xhr.open('GET', 'https://wshs-maps.onrender.com/wshs/map', true)
    xhr.setRequestHeader('Content-Type', 'application/json')
    xhr.send()
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        this.floors = { 1: {}, 2: {}, 3: {} }
        this.floors[1].metadata = JSON.parse(xhr.response)[1].metadata
        this.floors[2].metadata = JSON.parse(xhr.response)[2].metadata
        this.floors[3].metadata = JSON.parse(xhr.response)[3].metadata
        this.floors[1].path = new Path2D(JSON.parse(xhr.response)[1].path)
        this.floors[2].path = new Path2D(JSON.parse(xhr.response)[2].path)
        this.floors[3].path = new Path2D(JSON.parse(xhr.response)[3].path)
        this.floors[1].svg = `<svg width="250" height="196" viewBox="0 0 792 620" xmlns="http://www.w3.org/2000/svg"><path d="${JSON.parse(xhr.response)[1].metadata.outline}"/></svg>`
        this.floors[2].svg = `<svg width="250" height="159" viewBox="0 0 915 583" xmlns="http://www.w3.org/2000/svg"><path d="${JSON.parse(xhr.response)[2].metadata.outline}"/></svg>`
        this.floors[3].svg = `<svg width="250" height="158" viewBox="0 0 582 367" xmlns="http://www.w3.org/2000/svg"><path d="${JSON.parse(xhr.response)[3].metadata.outline}"/></svg>`

        navigator.geolocation.watchPosition(
          pos => this.calculate_position(pos.coords.longitude, pos.coords.latitude, this.position.z),
          err => this.position = { x: null, y: null, z: 2 },
          { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
        )
      }
    }

    window.onresize = () => this.width = window.innerWidth
  },
  methods: {
    room_exists(name) {
      for (let [_, floor] of Object.entries(this.floors))
        if (floor.metadata.rooms.some(room => room.name === name))
          return true
      return false
    },
    get_node(name) {
      if (name === 'Your Location')
        return [[this.position.z, this.position.x, this.position.y]]

      let openings = {}
      Object.keys(this.floors).forEach(floor => {
        const room = this.floors[floor].metadata.rooms.find(room => room.name === name)
        if (room)
          openings = room.openings.map(i => [parseInt(floor), ...i])
      })

      return openings
    },
    get_floor(name) {
      let floor_index = 2
      Object.keys(this.floors).forEach(floor => {
        if (this.floors[floor].metadata.rooms.some(room => room.name === name))
          floor_index = parseInt(floor)
      })
      return floor_index
    },
    set_path(room1, room2) {
      let xhr = new XMLHttpRequest()
      xhr.open('POST', 'https://wshs-maps.onrender.com/wshs/route', true)
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.send(JSON.stringify({
        start: this.get_node(room1),
        end: this.get_node(room2),
        include_elevators: false
      }))
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status === 200)
          this.path = JSON.parse(xhr.response).path.map(p => ({ floor: p.floor, path: new Path2D(p.path) }))
      }
    },
    calculate_position(long, lat, z) {
      const a = this.floors[z].metadata.orientation.angle*Math.PI/180
      const proj_x = (long-this.floors[z].metadata.orientation.origin[1])/this.floors[z].metadata.orientation.scale[0]
      const proj_y = (this.floors[z].metadata.orientation.origin[0]-lat)/this.floors[z].metadata.orientation.scale[1]
      let p = {
        x: proj_x * Math.cos(a) + proj_y * Math.sin(a),
        y: proj_y * Math.cos(a) - proj_x * Math.sin(a)
      }
      this.position = this.floors[z].metadata.hallways.reduce((closest, hall) => {
        let atob = [hall[2]-hall[0], hall[3]-hall[1]]
        let atop = [p.x-hall[0], p.y-hall[1]]
        let len = atob[0]*atob[0]+atob[1]*atob[1]
        let dot = atop[0]*atob[0]+atop[1]*atob[1]
        let t = Math.min(1, Math.max(0, dot/len))
        dot = (hall[2]-hall[0])*(p.y-hall[1])-(hall[3]-hall[1])*(p.x-hall[0])
        const new_p = { x: hall[0]+atob[0]*t, y: hall[1]+atob[1]*t, z }
        const new_p_dist = Math.hypot(new_p.x-p.x, new_p.y-p.y)

        if (new_p_dist < closest[1])
          return [new_p, new_p_dist]
        return closest
      }, [{}, Infinity])[0]
    },
    select_position(event) {
      const orientation = this.floors[this.position.z].metadata.orientation
      const a = orientation.angle*Math.PI/180
      const long = orientation.origin[1] + orientation.scale[0] * (this.position.x*Math.cos(a) - this.position.y*Math.sin(a))
      const lat = orientation.origin[0] - orientation.scale[1] *  (this.position.x*Math.sin(a) + this.position.y*Math.cos(a))
      this.calculate_position(long, lat, parseInt(event.target.value))

      if (this.room_exists(this.route_destination))
        this.set_path('Your Location', this.route_destination)
    },
    update_search_suggestions(e) {
      this.search_suggestions = this.update_place_suggestions(e).map(name => ({
        name,
        floor: this.get_floor(name)
      }))
    },
    update_endpoint_suggestions(e) {
      this.endpoint_suggestions = this.endpoint_suggestions[0]==='Your Location'
                                ? ['Your Location', ...this.update_place_suggestions(e)]
                                : this.update_place_suggestions(e)

      if ((this.room_exists(this.route_start) || this.route_start==='Your Location') && this.room_exists(this.route_destination))
        this.set_path(this.route_start, this.route_destination)
    },
    update_place_suggestions(e) {
      return this.floors[1].metadata.rooms.concat(this.floors[2].metadata.rooms)
                                          .concat(this.floors[3].metadata.rooms)
                                          .reduce((suggestions, room) => {
                                            if (e.target.value === '')
                                              return suggestions
                                            if (room.name.toLowerCase().includes(e.target.value.toLowerCase()))
                                              return [...suggestions, room.name]
                                            if (room.related.some(relation => relation.toLowerCase().includes(e.target.value.toLowerCase())))
                                              return [...suggestions, `${room.name} - ${room.related.find(relation => relation.toLowerCase().includes(e.target.value.toLowerCase()))}`]
                                            return suggestions
                                          }, [])
    },
    select_place(place, endpoint) {
      this.clear_location()
      this.route_endpoint = ''
      this.endpoint_suggestions = []
      this.select_route = true

      if (endpoint === 'start')
        this.route_start = place
      if (endpoint === 'end')
        this.route_destination = place
      if (this.route_start === '' && this.route_destination !== '')
        this.route_start = 'Your Location'

      if ((this.room_exists(this.route_start) || this.route_start==='Your Location') && this.room_exists(this.route_destination))
        this.set_path(this.route_start, this.route_destination)
    },
    endpoint_input_focus(endpoint) {
      this.route_endpoint = endpoint
      if (endpoint === 'start')
        this.endpoint_suggestions = ['Your Location']
    },
    set_location(new_location) {
      this.search_suggestions = []
      this.current_floor = new_location.floor
      if (this.select_route && this.route_start === '' && this.route_destination !== '')
        this.select_place(new_location.name, 'start')
      else if (this.select_route && this.route_start !== '' && this.route_destination === '')
        this.select_place(new_location.name, 'end')
      else
        this.location = {
          src: new_location.src,
          name: new_location.name,
          floor: new_location.floor
        }
    },
    clear_location() {
      this.location.name = ''
      this.location.floor = 0
      this.location.src = ''
    },
    clear_route() {
      this.path = []
      this.select_route = false
      this.route_start = ''
      this.route_endpoint = ''
      this.route_destination = ''
      this.endpoint_suggestions = []
    },
    clear_suggestions() {
      this.search_suggestions = []
    },
    directions_transition() {
      this.location.style.info_margin = '-400px'
      this.location.style.directions_margin = '0'
    },
    info_transition() {
      this.location.style.info_margin = '0'
      this.location.style.directions_margin = '400px'
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@600&display=swap');

#home {
  width: 100vw;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
  background-color: #faf7f0;
}

/*     Route Card     */
#select-route {
  overflow: hidden;
  border-radius: 10px;
  background-color: white;
  box-shadow: 0 0 20px 0 #0000004d;
}

#select-route header {
  font-size: 32px;
  margin-top: 20px;
  font-weight: bold;
}

.select-place {
  display: flex;
  width: 250px;
  outline: none;
  overflow: hidden;
  border-radius: 5px;
  border-radius: 5px;
  margin: 5px auto 10px;
  flex-direction: row;
  border: 1px solid #f3f5f4;
  background-color: #f3f5f4;
  padding: 12px 20px 12px 10px;
}
.select-place:last-child { margin: 0 auto 30px; }

.select-place select {
  border: none;
  color: #757575;
  outline: none;
  cursor: pointer;
  font-size: 16px;
  background-color: #f3f5f4;
}

.select-place input {
  width: 250px;
  border: none;
  outline: none;
  cursor: pointer;
  margin-left: 10px;
  background-color: #f3f5f4;
}
.select-place input:focus { cursor: default; }

.select-place i {
  color: #757575;
  font-size: 20px;
  margin-left: 10px;
}

.close-card {
  position: absolute;
  right: 0;
  cursor: pointer;
  fill: #999;
}
.card-padding { padding: 10px; }
.close-card:hover { fill: #333; }

#location-search-result {
  height: 100px;
  overflow: auto;
}

#destination {
  height: 50%;
  margin: 0 20px;
}

.location-search-item {
  display: flex;
  height: 40px;
  padding: 0 50px;
  cursor: pointer;
  align-items: center;
  flex-direction: row;
}
.location-search-item i { margin-right: 10px; }
.location-search-item:hover { background-color: #f2f4f7; }

/*     Location Card     */
#location {
  display: grid;
  overflow: hidden;
  border-radius: 10px;
  background-color: white;
  box-shadow: 0 0 20px 0 #0000004d;
}

#location-info {
  display: flex;
  width: 400px;
  transition: .5s;
  padding: 30px 0;
  grid-area: 1 / 1;
  align-items: center;
  flex-direction: column;
}
#location-info h1 { margin: 10px 0 0; }
#location-info p { margin: 5px 0 20px; }

#location-info div {
  display: flex;
  flex-direction: row;
}

#location-info button {
  display: flex;
  border: 0;
  outline: 0;
  color: #14a4eb;
  font-size: 15px;
  cursor: pointer;
  align-items: center;
  flex-direction: column;
  background-color: white;
  font-family: 'Poppins', sans-serif;
}
#location-info button:not(:last-child) { margin-right: 20px; }

#location-info button img {
  width: 40px;
  height: 40px;
  transition: 0.7s;
  margin-bottom: 5px;
}
#location-info button:hover > img { transform: scale(1.2) rotate(20deg); }

#room-icon {
  height: 50px;
}
/*     Portrait Location Card     */
#location-portrait {
  position: absolute;
  display: none;
  width: 100vw;
  bottom: 0;
  overflow: hidden;
  background-color: white;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  box-shadow: 0 0 20px 0 #0000004d;
  z-index: 5;
}

#pill-container {
  width: 100vw;
  padding: 10px 0;
  cursor: pointer;
}
#pill-container:hover > #pill { background-color: #666; }

#pill {
  width: 40px;
  height: 5px;
  margin: 0 auto;
  border-radius: 50vh;
  background-color: #999;
}

#location-info-portrait h1 {
  margin-top: 1em;
  margin-bottom: 0;
}

#location-info-portrait p {
  margin-top: 0;
}

#location-portrait-buttons {
  display: flex;
  width: 90vw;
  margin: 1em auto;
  padding: 2vw 0;
  flex-direction: row;
  justify-content: space-evenly;
}

#location-portrait button {
  display: flex;
  border: 0;
  outline: 0;
  color: #70757a;
  font-size: 14px;
  cursor: pointer;
  align-items: center;
  flex-direction: column;
  background-color: inherit;
  justify-content: flex-end;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

#location-portrait-buttons img {
  width: 40px;
  margin-bottom: 8px;
}

/*     Floor Selector     */
#select-floor {
  position: absolute;
  display: flex;
  right: 20px;
  bottom: 20px;
  transition: .7s;
  overflow: hidden;
  flex-direction: column;
  z-index: 1;
}

div.floor-select-opened {
  width: 400px;
  height: 270px;
  border-radius: 20px;
  background-color: #faf7f0;
  border: 2px solid #abb5a4;
}

svg.floor-select-opened {
  width: 30px;
  height: 30px;
  fill: #999;
  margin: 10px 10px 55px auto;
  cursor: pointer;
  transition: fill .5s;
  background-color: #faf7f0;
}
svg.floor-select-opened:hover { fill: #333; }

div.floor-select-closed {
  width: 50px;
  height: 50px;
  background-color: #faf7f0;
}

svg.floor-select-closed {
  width: 30px;
  height: 30px;
  padding: 10px;
  border-radius: 50%;
  background-color: #14a4eb;
  cursor: pointer;
}

#select-floor div:not(:last-child) {
  margin-bottom: -220px;
}

.floor, .active-floor  {
  transform: rotateX(50deg) rotateZ(20deg);
}

.floor {
  fill: #faf7f0;
  stroke: black;
  cursor: pointer;
  stroke-width: 2px;
}

.floor svg:hover {
  fill: #faf7f0;
  stroke: black;
  stroke-width: 10px;
}

.active-floor {
  fill: #022d6b;
  stroke: #022d6b;
}

#select-floor h2 {
  width: max-content;
  grid-area: floor-number;
}


/*     Open App Card     */
#open-app {
  position: fixed;
  bottom: 10px;
  margin: 0 8vw;
  overflow: hidden;
  padding: 15px 0 35px;
  border-radius: 20px;
  background-color: white;
  box-shadow: 0 0 20px 0 #0000004d;
  z-index: 10;
}
#open-app .close-card { margin-top: -15px; }

#open-app div {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
}

.close-app-promo {
  cursor: pointer;
  fill: #999;
  margin-right: 10px;
}

#open-app h1 {
  margin: 0;
  padding: 0 40px;
  font-size: 28px;
}

#open-app p {
  text-align: start;
  margin-left: 40px;
  margin-right: 40px;
  margin-bottom: 25px;
}

#open-app a {
  color: white;
  padding: 10px 20px;
  border-radius: 10px;
  text-decoration: none;
  background-color: #14A4EB;
}

@media (min-width: 600px) and (max-width: 768px) {
  #location-portrait-buttons { width: 70vw; }
}

@media (max-width: 768px) {
  #location { display: none; }
  #location-portrait { display: block; }

  #select-route { margin: 0 10px; }
  .close-card { right: 10px; }

  #select-floor {
    right: 40px;
    bottom: 40px;
  }

  .select-place, .select-place input { width: calc(100vw - 150px); }

  div.floor-select-opened {
    width: calc(100vw - 80px);
  }
}
</style>